import template from './sw-cms-el-acris-blog-author-date.html.twig';
import './sw-cms-el-acris-blog-author-date.scss';

const { Component, Mixin } = Shopware;

Component.register('sw-cms-el-acris-blog-author-date', {
    template,

    mixins: [
        Mixin.getByName('cms-element')
    ],

    created() {
        this.createdComponent();
    },

    methods: {
        createdComponent() {
            this.initElementConfig('acris-blog-author-date');
        },
    }
});